import { render } from "./WarrantyTypeChip.vue?vue&type=template&id=8a272b90"
import script from "./WarrantyTypeChip.vue?vue&type=script&lang=js"
export * from "./WarrantyTypeChip.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__